import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["vrt-method-icon", `vrt-method-icon-${_ctx.method}`]),
    "aria-hidden": "true"
  }, null, 2))
}